import { i18next } from '@frontend/i18n';
import { MAX_CALENDAR_LOCATION_COUNT } from '../../constants';

const numberWords = [
  i18next.t('zero', { ns: 'schedule' }),
  i18next.t('one', { ns: 'schedule' }),
  i18next.t('two', { ns: 'schedule' }),
  i18next.t('three', { ns: 'schedule' }),
  i18next.t('four', { ns: 'schedule' }),
];

export const getHelperText = (count: number) => {
  // 'count' is the number of locations selected in the modal. It will never be more than MAX_CALENDAR_LOCATION_COUNT because of the selection limit.
  if (count === 0) return i18next.t('Select at least one location', { ns: 'schedule' });
  if (count === 1) return i18next.t('View one location', { ns: 'schedule' });
  return i18next.t('View {{word}} locations', { ns: 'schedule', word: numberWords[count] });
};

export const getSelectedLocationsHeader = (
  modalLocationsSelectedCount: number,
  globallySelectedLocationsCount: number
) => {
  if (
    globallySelectedLocationsCount > MAX_CALENDAR_LOCATION_COUNT &&
    modalLocationsSelectedCount === MAX_CALENDAR_LOCATION_COUNT
  )
    return i18next.t("We've Picked {{limit}} Locations for You", {
      ns: 'schedule',
      limit: MAX_CALENDAR_LOCATION_COUNT,
    });
  return i18next.t('Select up to {{limit}} Locations', { ns: 'schedule', limit: MAX_CALENDAR_LOCATION_COUNT });
};

export const getSelectedLocationsDescription = (
  modalLocationsSelectedCount: number,
  globallySelectedLocationsCount: number
) => {
  if (
    globallySelectedLocationsCount > MAX_CALENDAR_LOCATION_COUNT &&
    modalLocationsSelectedCount === MAX_CALENDAR_LOCATION_COUNT
  )
    return i18next.t(
      "For your convenience and to optimize our system's performance, we've preselected {{limit}} relevant locations for you to view. Modify your selections below, or continue with our suggestions.",
      { ns: 'schedule', limit: numberWords[MAX_CALENDAR_LOCATION_COUNT] }
    );
  return i18next.t('Select the locations you want to view on the calendar. You can select up to {{limit}} locations.', {
    ns: 'schedule',
    limit: numberWords[MAX_CALENDAR_LOCATION_COUNT],
  });
};
